/**
 * @file コンポーネント：コンテンツメニュー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledMenu = styled.nav`
    position: fixed;
    top: 64px;
    left: 0;
    z-index: ${zIndex.header};
    width: 100%;
    overflow-x: auto;
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
    background-color: #ffffff;

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    &:hover::-webkit-scrollbar {
        width: 16px;
        height: 16px;
    }
`;

export const StyledMenuButton = styled.button`
    display: block;
    min-width: 72px;
    margin: 0;
    padding: 4px 8px;
    border: none;
    background-color: transparent;
    color: #757575;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    white-space: nowrap;

    &.is-active {
        padding-bottom: 2px;
        border-bottom: 2px solid #007dff;
        background-color: #f5f5f5;
        color: #007dff;
        font-weight: bold;
    }
`;

export const StyledMenuList = styled.ul`
    display: flex;
`;

export const StyledMenuListItem = styled.li``;
